import { useState } from "react";
import { IconButton, Snackbar } from "@mui/material";
import FileCopy from "@mui/icons-material/FileCopyOutlined";

const CopyToClipboardButton = (props) => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        console.log(props.message)
        setOpen(true);
        try {
            navigator.clipboard.writeText(props.value)
        }
        catch (error){
            console.error(error)
        }
        console.log({open})
    };

    return (
        <>
            <IconButton onClick={handleClick} color="primary">
                <FileCopy />
            </IconButton>
            <Snackbar
                message={props.message}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={1200}
                onClose={() => setOpen(false)}
                open={open}
            />
        </>
    );
};

export default CopyToClipboardButton;